import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { readFundingActionRecovery } from './action-recovery.js';
import { useFundingFunnel } from './funnel-react.js';
/** Canonical completion invalidates the receipt; private customer requirements are not persisted. */
export function useFundingActionRecovery(client, provider, operationId) {
  const $ = _c(20);
  const cache = useQueryClient();
  let t0;
  if ($[0] !== client.cacheKey || $[1] !== operationId) {
    t0 = ["onramp", client.cacheKey, "action-recovery", operationId];
    $[0] = client.cacheKey;
    $[1] = operationId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const queryKey = t0;
  let t1;
  if ($[3] !== cache || $[4] !== client || $[5] !== operationId || $[6] !== provider) {
    t1 = async t2 => {
      const {
        signal
      } = t2;
      const recovered = await readFundingActionRecovery(client, provider, operationId, signal);
      if (recovered.state === "complete") {
        await cache.invalidateQueries({
          queryKey: ["onramp", client.cacheKey, "operation", operationId]
        });
      }
      return recovered;
    };
    $[3] = cache;
    $[4] = client;
    $[5] = operationId;
    $[6] = provider;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      persist: false
    };
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== queryKey || $[10] !== t1) {
    t3 = {
      queryKey,
      queryFn: t1,
      retry: false,
      gcTime: 0,
      refetchOnWindowFocus: false,
      meta: t2
    };
    $[9] = queryKey;
    $[10] = t1;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const result = useQuery(t3);
  let t4;
  let t5;
  if ($[12] !== cache || $[13] !== client) {
    t4 = () => client.onDispose(() => {
      cache.cancelQueries({
        queryKey: ["onramp", client.cacheKey, "action-recovery"]
      });
      cache.removeQueries({
        queryKey: ["onramp", client.cacheKey, "action-recovery"]
      });
    });
    t5 = [client, cache];
    $[12] = cache;
    $[13] = client;
    $[14] = t4;
    $[15] = t5;
  } else {
    t4 = $[14];
    t5 = $[15];
  }
  useEffect(t4, t5);
  const t6 = result.isFetching ? "loading" : result.isError ? "error" : "ready";
  const t7 = result.isError ? "onramp_action_recovery_unavailable" : null;
  let t8;
  if ($[16] !== operationId || $[17] !== t6 || $[18] !== t7) {
    t8 = {
      stage: "customer_verification",
      operationId,
      outcome: t6,
      errorCode: t7
    };
    $[16] = operationId;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  useFundingFunnel(client, t8);
  return result;
}